import { AbstractCoroutine2jzyhqo91sb0o as AbstractCoroutine } from '../AbstractCoroutine.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { JobCancellationException2g3wpni5v5fkt as JobCancellationException } from '../Exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  close$default1evna6yun3t5h as close$default,
  SendChannel38sllbxw662ws as SendChannel,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
} from './Channel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelCoroutineClass;
function ChannelCoroutine() {
  if (ChannelCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(parentContext, _channel, initParentJob, active) {
        super(parentContext, initParentJob, active);
        this.y1b_1 = _channel;
      }
      hx(cause) {
        if (this.uw())
          return Unit_instance;
        var tmp;
        if (cause == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().w14(null == null ? this.bw() : null, null, this);
        } else {
          tmp = cause;
        }
        this.jx(tmp);
      }
      m1b(cause, $super) {
        return this.ix(cause, ($super == null ? true : $super instanceof ChannelCoroutine()) ? $super : THROW_CCE());
      }
      jx(cause) {
        var exception = this.zw(cause);
        this.y1b_1.hx(exception);
        this.mx(exception);
      }
      q1a() {
        return this.y1b_1.q1a();
      }
      *x1a(element, $completion) {
        yield* this.y1b_1.x1a(element, $completion);
        return Unit_instance;
      }
      y1a(element) {
        return this.y1b_1.y1a(element);
      }
      i1b(cause) {
        return this.y1b_1.i1b(cause);
      }
      *b1b($completion) {
        return yield* this.y1b_1.b1b($completion);
      }
      p1() {
        return this.y1b_1.p1();
      }
    }
    protoOf($).k1b = close$default;
    initMetadataForClass($, 'ChannelCoroutine', VOID, VOID, [SendChannel(), ReceiveChannel()], [1, 0]);
    ChannelCoroutineClass = $;
  }
  return ChannelCoroutineClass;
}
//region block: exports
export {
  ChannelCoroutine as ChannelCoroutine12l2gxei4u780,
};
//endregion

//# sourceMappingURL=ChannelCoroutine.mjs.map
